import * as React from 'react';
import { createIngestedDatasetDetailPath } from 'src/components/ingestion/common/navigation';
import { iTethysRouteProps } from 'src/components/ingestion/common/types';
import { UX_WRITING } from 'src/components/ingestion/common/uxWriting';
import { BreadcrumbGroup } from '@amzn/awsui-components-react-v3';
import { NONE, WEBSITE_NAME } from '../commons/constants';
import {
  createAdvisoryDetailsLink,
  createBootstrapActionLink,
  createResourceGroupLink,
  createResourceManagerTemplateLink,
  createReviewDetailsLink,
  Page,
} from 'src/routes';

// --- Constants ---

const DATA_INGESTION_TITLE = 'Data ingestion';

// --- Helpers ---

export const createBreadcrumbs = (items) => {
  return (props) => <BreadcrumbGroup onFollow={props.onFollow} items={items} ariaLabel='Breadcrumbs' />;
};

export const createDynamicBreadcrumbs = (getItems) => {
  return (props) => <BreadcrumbGroup onFollow={props.onFollow} items={getItems(props)} ariaLabel='Breadcrumbs' />;
};

// --- Catalogs ---

export const browseCatalogs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse catalogs',
    href: NONE,
  },
];
export const catalogDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse catalogs',
    href: Page.BROWSE_CATALOGS,
  },
  {
    text: name,
    href: NONE,
  },
];
export const BreadcrumbsBrowseCatalogs = createBreadcrumbs(browseCatalogs);
export const BreadcrumbsCatalogDetails = createDynamicBreadcrumbs((props) => catalogDetails(props.activeCatalogName));

// --- Databases ---

export const browseDatabases = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse databases',
    href: NONE,
  },
];
export const databaseDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse databases',
    href: Page.BROWSE_DATABASES,
  },
  {
    text: name,
    href: NONE,
  },
];
export const BreadcrumbsBrowseDatabases = createBreadcrumbs(browseDatabases);
export const BreadcrumbsDatabaseDetails = createDynamicBreadcrumbs((props) =>
  databaseDetails(props.activeDatabaseName),
);

// --- Datasets ---

export const browseDatasets = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse datasets',
    href: NONE,
  },
];
export const datasetDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse datasets',
    href: Page.BROWSE_DATASETS,
  },
  {
    text: name,
    href: NONE,
  },
];
export const BreadcrumbsBrowseDatasets = createBreadcrumbs(browseDatasets);
export const BreadcrumbsDatasetDetails = createDynamicBreadcrumbs((props) => datasetDetails(props.activeDatasetName));

export const myDatasets = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Datasets',
    href: NONE,
  },
];
export const myDatasetsDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Datasets',
    href: Page.MY_DATASETS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsMyDatasets = createBreadcrumbs(myDatasets);
export const BreadcrumbsMyDatasetsDetails = createDynamicBreadcrumbs((props) =>
  myDatasetsDetails(props.match.params.id),
);

// --- Publishing ---

export const publish = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Publish',
    href: Page.PUBLISH,
  },
];
export const publisherTables = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: DATA_INGESTION_TITLE,
    href: NONE,
  },
];
export const publisherRegisterTable = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: DATA_INGESTION_TITLE,
    href: Page.PUBLISHER_TABLES,
  },
  {
    text: 'Register table',
    href: NONE,
  },
];
export const BreadcrumbsPublish = createBreadcrumbs(publish);
export const BreadcrumbsPublishedTables = createBreadcrumbs(publisherTables);
export const BreadcrumbsPublishRegisterTable = createBreadcrumbs(publisherRegisterTable);

// --- Permissions ---

export const createLakeFormationPermission = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access requests',
    href: Page.MY_DATASETS,
  },
  {
    text: 'Create Lake Formation permission',
    href: NONE,
  },
];
export const permissionRequestDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access requests',
    href: Page.REQUESTS,
  },
  {
    text: name,
    href: NONE,
  },
];
export const consumedPermissions = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data access permissions',
    href: Page.WORKSPACE_ALL_PERMISSIONS,
  },
];
export const wsPermissionDetail = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data access permissions',
    href: Page.WORKSPACE_ALL_PERMISSIONS,
  },
  {
    text: name,
    href: NONE,
  },
];
export const listRequests = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access requests',
    href: NONE,
  },
];
export const BreadcrumbsCreateLakeFormationPermission = createBreadcrumbs(createLakeFormationPermission);
export const BreadcrumbsPermissionRequestDetails = createDynamicBreadcrumbs((props) =>
  permissionRequestDetails(props.match.params.id),
);
export const BreadcrumbsPermissionDetail = createDynamicBreadcrumbs((props) =>
  wsPermissionDetail(props.match.params.permissionId),
);
export const BreadcrumbsConsumedPermissions = createBreadcrumbs(consumedPermissions);
export const BreadcrumbsListRequests = createBreadcrumbs(listRequests);

// --- Groups ---

export const createNewGroup = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Groups',
    href: Page.GROUPS,
  },
  {
    text: 'Create new group',
    href: NONE,
  },
];
export const myGroup = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'My group',
    href: Page.GROUPS,
  },
];
export const myGroups = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Groups',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsCreateNewGroup = createBreadcrumbs(createNewGroup);
export const BreadcrumbsMyGroup = createBreadcrumbs(myGroup);
export const BreadcrumbsMyGroups = createDynamicBreadcrumbs((props) => myGroups(props.match.params.id));

// --- Tags ---

export const tags = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'My permissions tags',
    href: Page.TAGS,
  },
];
export const createTag = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'My permissions tags',
    href: Page.TAGS,
  },
  {
    text: 'Create tag',
    href: NONE,
  },
];
export const editTag = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'My permissions tags',
    href: Page.TAGS,
  },
  {
    text: 'Edit tag',
    href: NONE,
  },
];
export const BreadcrumbsTags = createBreadcrumbs(tags);
export const BreadcrumbsCreateTag = createBreadcrumbs(createTag);
export const BreadcrumbsEditTag = createBreadcrumbs(editTag);

// --- Workspaces ---

export const browseWorkspaces = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse workspaces',
    href: NONE,
  },
];
export const createWorkspace = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Workspaces',
    href: Page.BROWSE_WORKSPACES,
  },
  {
    text: 'Create workspace',
    href: NONE,
  },
];
export const workspaceDetail = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Workspaces',
    href: Page.BROWSE_WORKSPACES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const updateWorkspace = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Workspaces',
    href: Page.BROWSE_WORKSPACES,
  },
  {
    text: 'Edit ' + id,
    href: NONE,
  },
];
export const wsDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Workspaces',
    href: NONE,
  },
  {
    text: name,
    href: NONE,
  },
];
export const workspace_tag_accesses = (_) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Existing workspace access',
    href: Page.WORKSPACEACCESS,
  },
];
export const BreadcrumbsBrowseWorkspaces = createBreadcrumbs(browseWorkspaces);
export const BreadcrumbsCreateWorkspace = createBreadcrumbs(createWorkspace);
export const BreadcrumbsWorkspaceDetail = createDynamicBreadcrumbs((props) =>
  workspaceDetail(props.match.params.workspaceId),
);
export const BreadcrumbsUpdateWorkspace = createDynamicBreadcrumbs((props) =>
  updateWorkspace(props.match.params.workspaceId),
);
export const BreadcrumbsWSDetails = createDynamicBreadcrumbs((props) => wsDetails(props.match.params.workspaceId));
export const BreadCrumbsWorkspaceTagAccess = createDynamicBreadcrumbs((props) =>
  workspace_tag_accesses(props.match.params.id),
);

// --- Workspace Resources ---

export const searchData = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Search data',
    href: NONE,
  },
];
export const schemaDetails = (schema) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse databases',
    href: Page.WORKSPACES_BROWSE_DATABASES,
  },
  {
    text: schema,
    href: NONE,
  },
];
export const wsDatasetDetails = (name) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Browse workspace datasets',
    href: Page.WORKSPACES_BROWSE_DATASETS,
  },
  {
    text: name,
    href: NONE,
  },
];
export const wsTagDetails = (tagid) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Tags',
    href: NONE,
  },
  {
    text: `${tagid.split(':')[0]}:${tagid.split(':')[1]}`,
    href: NONE,
  },
];
export const wsGlueRegister = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Register Glue data',
    href: NONE,
  },
];
export const wsRedshiftRegister = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Register Redshift data',
    href: NONE,
  },
];
export const wsTagRegister = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Register tag',
    href: NONE,
  },
];
export const wsResourceLinks = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Athena query',
    href: NONE,
  },
];
export const wsRedshiftQuery = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Redshift query',
    href: NONE,
  },
];
export const BreadcrumbsSearchData = createBreadcrumbs(searchData);
export const BreadcrumbsSchemaDetails = createDynamicBreadcrumbs((props) => schemaDetails(props.activeDatabaseName));
export const BreadcrumbsWSDatasetDetails = createDynamicBreadcrumbs((props) =>
  wsDatasetDetails(props.activeDatasetName),
);
export const BreadcrumbsWSTagDetails = createDynamicBreadcrumbs((props) => wsTagDetails(props.match.params.tagid));
export const BreadcrumbsWSGlueRegister = createBreadcrumbs(wsGlueRegister);
export const BreadcrumbsWSRedshiftRegister = createBreadcrumbs(wsRedshiftRegister);
export const BreadcrumbsWSTagRegister = createBreadcrumbs(wsTagRegister);
export const BreadcrumbsWSResourceLinks = createBreadcrumbs(wsResourceLinks);
export const BreadcrumbsWSRedshiftQuery = createBreadcrumbs(wsRedshiftQuery);

// --- Templates ---

export const templates = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Templates',
    href: NONE,
  },
];
export const create_template = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Templates',
    href: Page.TEMPLATES,
  },
  {
    text: 'Create new template',
    href: NONE,
  },
];
export const template_view = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Templates',
    href: Page.TEMPLATES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const edit_template = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Templates',
    href: Page.TEMPLATES,
  },
  {
    text: 'Edit template',
    href: NONE,
  },
];
export const BreadcrumbsTemplates = createBreadcrumbs(templates);
export const BreadcrumbsCreateTemplate = createBreadcrumbs(create_template);
export const BreadcrumbsTemplateView = createDynamicBreadcrumbs((props) =>
  template_view(props.match.params.templateId),
);
export const BreadcrumbsEditTemplate = createBreadcrumbs(edit_template);

// --- Classification ---

export const classification = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Classification',
    href: NONE,
  },
];
export const BreadcrumbsClassification = createBreadcrumbs(classification);

// --- Business Glossaries ---

export const businessGlossaries = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Business glossaries',
    href: NONE,
  },
];
export const createBusinessGlossary = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Business glossaries',
    href: Page.BUSINESS_GLOSSARIES,
  },
  {
    text: 'Create glossary',
    href: NONE,
  },
];
export const editBusinessGlossary = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Business glossaries',
    href: Page.BUSINESS_GLOSSARIES,
  },
  {
    text: 'Edit glossary',
    href: NONE,
  },
];
export const viewBusinessGlossary = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Business glossaries',
    href: Page.BUSINESS_GLOSSARIES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsBusinessGlossaries = createBreadcrumbs(businessGlossaries);
export const BreadcrumbsCreateBusinessGlossary = createBreadcrumbs(createBusinessGlossary);
export const BreadcrumbsViewBusinessGlossary = createDynamicBreadcrumbs((props) =>
  viewBusinessGlossary(props.match.params.id),
);
export const BreadcrumbsEditBusinessGlossary = createBreadcrumbs(editBusinessGlossary);

// --- Governance Tags ---

export const governanceTags = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Governance tags',
    href: NONE,
  },
];
export const createGovernanceTag = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Governance tags',
    href: Page.GOVERNANCE_TAGS,
  },
  {
    text: 'Create governance tag',
    href: NONE,
  },
];
export const editGovernanceTag = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Governance tags',
    href: Page.GOVERNANCE_TAGS,
  },
  {
    text: 'Update governance tag',
    href: NONE,
  },
];
export const viewGovernanceTag = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Governance tags',
    href: Page.GOVERNANCE_TAGS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsGovernanceTags = createBreadcrumbs(governanceTags);
export const BreadcrumbsCreateGovernanceTag = createBreadcrumbs(createGovernanceTag);
export const BreadcrumbsViewGovernanceTag = createDynamicBreadcrumbs((props) =>
  viewGovernanceTag(props.match.params.id),
);
export const BreadcrumbsEditGovernanceTag = createBreadcrumbs(editGovernanceTag);

// --- Metadata Forms ---

export const metadataForms = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metadata forms',
    href: NONE,
  },
];
export const createMetadataForm = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metadata forms',
    href: Page.METADATA_FORMS,
  },
  {
    text: 'Create form',
    href: NONE,
  },
];
export const editMetadataForm = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metadata forms',
    href: Page.METADATA_FORMS,
  },
  {
    text: 'Edit form',
    href: NONE,
  },
];
export const viewMetadataForm = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metadata forms',
    href: Page.METADATA_FORMS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsMetadataForms = createBreadcrumbs(metadataForms);
export const BreadcrumbsCreateMetadataForm = createBreadcrumbs(createMetadataForm);
export const BreadcrumbsViewMetadataForm = createDynamicBreadcrumbs((props) => viewMetadataForm(props.match.params.id));
export const BreadcrumbsEditMetadataForm = createBreadcrumbs(editMetadataForm);

// --- Fine Grain Access Policies ---

export const fineGrainAccessPolicies = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Fine grain access policies',
    href: NONE,
  },
];
export const createFgaPolicy = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Fine grain access policies',
    href: Page.FINE_GRAIN_ACCESS_POLICIES,
  },
  {
    text: 'Create access policy',
    href: NONE,
  },
];
export const editFgaPolicy = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Fine grain access policies',
    href: Page.FINE_GRAIN_ACCESS_POLICIES,
  },
  {
    text: 'Edit access policy',
    href: NONE,
  },
];
export const viewFgaPolicy = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Fine grain access policies',
    href: Page.FINE_GRAIN_ACCESS_POLICIES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsFgaPolicies = createBreadcrumbs(fineGrainAccessPolicies);
export const BreadcrumbsCreateFgaPolicy = createBreadcrumbs(createFgaPolicy);
export const BreadcrumbsViewFgaPolicy = createDynamicBreadcrumbs((props) => viewFgaPolicy(props.match.params.id));
export const BreadcrumbsEditFgaPolicy = createBreadcrumbs(editFgaPolicy);

// --- DataZone ---

export const dataZoneManage = () => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Manage DataZone resources',
    href: Page.DATAZONE_MANAGE,
  },
];
export const dataZoneOnboard = () => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Manage DataZone resources',
    href: Page.DATAZONE_MANAGE,
  },
  {
    text: 'Onboard',
    href: NONE,
  },
];
export const BreadcrumbsDataZoneManage = createBreadcrumbs(dataZoneManage());
export const BreadcrumbsDataZoneOnboard = createBreadcrumbs(dataZoneOnboard());

// --- Notifications ---

export const myNotifications = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: NONE,
  },
];
export const createNotification = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Create notification',
    href: NONE,
  },
];
export const notificationDetail = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification details',
    href: NONE,
  },
];
export const notificationBatchDetail = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification batch detail',
    href: NONE,
  },
];
export const notificationTemplates = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification templates',
    href: NONE,
  },
];
export const notificationConfiguration = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification settings',
    href: NONE,
  },
];
export const createNotificationTemplate = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification templates',
    href: Page.NOTIFICATION_TEMPLATES,
  },
  {
    text: 'Create notification template',
    href: NONE,
  },
];
export const updateNotificationTemplate = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification templates',
    href: Page.NOTIFICATION_TEMPLATES,
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const notificationTemplateDetail = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Notifications',
    href: Page.NOTIFICATIONS,
  },
  {
    text: 'Notification template',
    href: Page.NOTIFICATION_TEMPLATES,
  },
  {
    text: 'Notification template details',
    href: NONE,
  },
];
export const BreadcrumbsMyNotifications = createBreadcrumbs(myNotifications);
export const BreadcrumbsCreateNotifications = createBreadcrumbs(createNotification);
export const BreadcrumbsNotificationDetail = createBreadcrumbs(notificationDetail);
export const BreadcrumbsNotificationBatchDetail = createBreadcrumbs(notificationBatchDetail);
export const BreadcrumbsNotificationTemplates = createBreadcrumbs(notificationTemplates);
export const BreadcrumbsCreateNotificationTemplate = createBreadcrumbs(createNotificationTemplate);
export const BreadcrumbsUpdateNotificationTemplate = createBreadcrumbs(updateNotificationTemplate);
export const BreadcrumbsNotificationTemplateDetail = createBreadcrumbs(notificationTemplateDetail);
export const BreadcrumbsNotificationConfiguration = createBreadcrumbs(notificationConfiguration);

// --- Resource Groups ---

export const myResourceGroups = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: NONE,
  },
];
export const reosurcegroupFormNew = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: 'Create resource group',
    href: NONE,
  },
];
export const reosurcegroupFormUpdate = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: id,
    href: createResourceGroupLink(id),
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const resourcegroupDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const resourceDetails = (rgid, id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: rgid,
    href: createResourceGroupLink(rgid),
  },
  {
    text: 'Resources',
    href: createResourceGroupLink(rgid),
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsMyResourceGroups = createBreadcrumbs(myResourceGroups);
export const BreadcrumbsResourceGroupFormNew = createBreadcrumbs(reosurcegroupFormNew);
export const BreadcrumbsResourceGroupFormUpdate = createDynamicBreadcrumbs((props) =>
  reosurcegroupFormUpdate(props.match.params.id),
);
export const BreadcrumbsResourceGroupDetails = createDynamicBreadcrumbs((props) =>
  resourcegroupDetails(props.match.params.id),
);
export const BreadcrumbsResourceDetails = createDynamicBreadcrumbs((props) =>
  resourceDetails(props.match.params.rgid, props.match.params.id),
);

// --- Resource Group Templates ---

export const resourceGroupTemplateNew = () => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: 'Templates',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: 'Create template',
    href: NONE,
  },
];
export const resourceGroupTemplateUpdate = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: 'Templates',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: id,
    href: createResourceManagerTemplateLink(id),
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const resourceGroupTemplateDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Resource groups',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: 'Templates',
    href: Page.RESOURCEGROUPS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsTemplateNew = createBreadcrumbs(resourceGroupTemplateNew());
export const BreadcrumbsTemplateUpdate = createDynamicBreadcrumbs((props) =>
  resourceGroupTemplateUpdate(props.match.params.id),
);
export const BreadcrumbsTemplateDetails = createDynamicBreadcrumbs((props) =>
  resourceGroupTemplateDetails(props.match.params.id),
);

// --- Event Subscriptions ---

export const eventSubscriptions = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Event subscriptions',
    href: NONE,
  },
];
export const eventSubscriptionsDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Event subscriptions',
    href: Page.EVENT_SUBSCRIPTIONS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsEventSubscriptions = createBreadcrumbs(eventSubscriptions);
export const BreadcrumbsEventSubscriptionDetails = createDynamicBreadcrumbs((props) =>
  eventSubscriptionsDetails(props.match.params.id),
);

// --- Bootstrap Actions ---

export const myBootstrapActions = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Bootstrap actions',
    href: NONE,
  },
];
export const bootstrapactionFormNew = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Bootstrap actions',
    href: Page.BOOTSTRAPACTIONS,
  },
  {
    text: 'Create bootstrap action',
    href: NONE,
  },
];
export const bootstrapactionFormUpdate = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Bootstrap actions',
    href: Page.BOOTSTRAPACTIONS,
  },
  {
    text: id,
    href: createBootstrapActionLink(id),
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const bootstrapactionDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Bootstrap actions',
    href: Page.BOOTSTRAPACTIONS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsMyBootstrapActions = createBreadcrumbs(myBootstrapActions);
export const BreadcrumbsBootstrapActionFormNew = createBreadcrumbs(bootstrapactionFormNew);
export const BreadcrumbsBootstrapActionFormUpdate = createDynamicBreadcrumbs((props) =>
  bootstrapactionFormUpdate(props.match.params.id),
);
export const BreadcrumbsBootstrapActionDetails = createDynamicBreadcrumbs((props) =>
  bootstrapactionDetails(props.match.params.id),
);

// --- Baselining ---

export const myBaselining = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Baseline',
    href: NONE,
  },
];
export const baselineDataAccessPermission = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Baseline',
    href: Page.BASELINING,
  },
  {
    text: 'Data access permission',
    href: NONE,
  },
];
export const baselineMembership = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Baseline',
    href: Page.BASELINING,
  },
  {
    text: 'Owner',
    href: NONE,
  },
];
export const BreadcrumbsMyBaselining = createBreadcrumbs(myBaselining);
export const BreadcrumbsBaselineDataAccessPermission = createBreadcrumbs(baselineDataAccessPermission);
export const BreadcrumbsBaselineMembership = createBreadcrumbs(baselineMembership);

// --- Access Reviews ---

export const accessReviews = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access reviews',
    href: NONE,
  },
];
export const accessReviewDetail = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access reviews',
    href: Page.REVIEWS,
  },
  {
    text: id,
    href: createReviewDetailsLink(id),
  },
];
export const accessReviewCustodian = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access reviews',
    href: Page.REVIEWS,
  },
  {
    text: 'Custodian view',
    href: NONE,
  },
];
export const accessReviewHistory = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Access reviews',
    href: Page.REVIEWS,
  },
  {
    text: 'Review history',
    href: NONE,
  },
];
export const BreadcrumbsAccessReviews = createBreadcrumbs(accessReviews);
export const BreadcrumbsAccessReviewDetail = createDynamicBreadcrumbs((props) =>
  accessReviewDetail(props.match.params.reviewId),
);
export const BreadcrumbsAccessReviewCustodian = createBreadcrumbs(accessReviewCustodian);
export const BreadcrumbsAccessReviewHistory = createBreadcrumbs(accessReviewHistory);

// --- Advisories ---

export const listAdvisoriesBreadcrumbs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: NONE,
  },
];
export const createAdvisoryBreadcrumbs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: 'Create',
    href: NONE,
  },
];
export const createAdvisoryFromTemplateBreadcrumbs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: 'Create',
    href: NONE,
  },
];
export const createAdvisoryFromAdvisoryBreadcrumbs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: 'Create',
    href: NONE,
  },
];
export const editAdvisoryBreadcrumbs = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: id,
    href: createAdvisoryDetailsLink(id),
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const sendAdvisoryNotificationBreadcrumbs = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: id,
    href: createAdvisoryDetailsLink(id),
  },
  {
    text: 'Send notification',
    href: NONE,
  },
];
export const advisoryDetailsBreadcrumbs = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisories',
    href: Page.LIST_ADVISORIES,
  },
  {
    text: id,
    href: createAdvisoryDetailsLink(id),
  },
];
export const BreadcrumbsListAdvisories = createBreadcrumbs(listAdvisoriesBreadcrumbs);
export const BreadcrumbsCreateAdvisory = createBreadcrumbs(createAdvisoryBreadcrumbs);
export const BreadcrumbsCreateAdvisoryFromTemplate = createBreadcrumbs(createAdvisoryFromTemplateBreadcrumbs);
export const BreadcrumbsCreateAdvisoryFromAdvisory = createBreadcrumbs(createAdvisoryFromAdvisoryBreadcrumbs);
export const BreadcrumbsEditAdvisory = createDynamicBreadcrumbs((props) =>
  editAdvisoryBreadcrumbs(props.match.params.id),
);
export const BreadcrumbsSendAdvisoryNotification = createDynamicBreadcrumbs((props) =>
  sendAdvisoryNotificationBreadcrumbs(props.match.params.id),
);
export const BreadcrumbsAdvisoryDetail = createDynamicBreadcrumbs((props) =>
  advisoryDetailsBreadcrumbs(props.match.params.id),
);

// --- Advisory Templates ---

export const listAdvisoryTemplatesBreadcrumbs = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisory templates',
    href: NONE,
  },
];
export const editAdvisoryTemplateBreadcrumbs = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisory templates',
    href: Page.LIST_ADVISORY_TEMPLATES,
  },
  {
    text: id,
    href: createAdvisoryDetailsLink(id),
  },
  {
    text: 'Edit',
    href: NONE,
  },
];
export const advisoryTemplateDetailsBreadcrumbs = (id: string) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Data advisory templates',
    href: Page.LIST_ADVISORY_TEMPLATES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsListAdvisoryTemplates = createBreadcrumbs(listAdvisoryTemplatesBreadcrumbs);
export const BreadcrumbsEditAdvisoryTemplate = createDynamicBreadcrumbs((props) =>
  editAdvisoryTemplateBreadcrumbs(props.match.params.id),
);
export const BreadcrumbsAdvisoryTemplateDetail = createDynamicBreadcrumbs((props) =>
  advisoryTemplateDetailsBreadcrumbs(props.match.params.id),
);

// --- Data Ingestion ---

const ROOT_URL = {
  text: WEBSITE_NAME,
  href: Page.HOME,
};

const MANAGE_DATASETS = {
  text: DATA_INGESTION_TITLE,
  href: Page.PUBLISHER_TABLES,
};

const DATASET_DETAIL = (routeParams: iTethysRouteProps) => ({
  text: routeParams.dataset,
  href: createIngestedDatasetDetailPath(routeParams),
});

const registerContractBreadcrumbs = [
  ROOT_URL,
  MANAGE_DATASETS,
  {
    text: UX_WRITING.REGISTER_DATASET,
    href: Page.INGESTION.REGISTER_CONTRACT,
  },
];
export const BreadcrumbsRegisterContract = createBreadcrumbs(registerContractBreadcrumbs);

const updateContractBreadcrumbs = (routeParams: iTethysRouteProps) => [
  ROOT_URL,
  MANAGE_DATASETS,
  DATASET_DETAIL(routeParams),
  {
    text: 'Update dataset',
    href: NONE,
  },
];
export const BreadcrumbsUpdateContract = createDynamicBreadcrumbs(({ match }) =>
  updateContractBreadcrumbs(match.params),
);

const contractDetailBreadcrumbs = (dataset: string) => [
  ROOT_URL,
  MANAGE_DATASETS,
  {
    text: dataset,
    href: NONE,
  },
];
export const BreadcrumbsContractDetail = createDynamicBreadcrumbs((props) =>
  contractDetailBreadcrumbs(props.match.params.dataset),
);

const monitorDatasetBreadcrumbs = (routeParams: iTethysRouteProps) => [
  ROOT_URL,
  MANAGE_DATASETS,
  DATASET_DETAIL(routeParams),
  {
    text: 'Monitoring',
    href: NONE,
  },
];
export const BreadcrumbsMonitoringDataset = createDynamicBreadcrumbs((props) =>
  monitorDatasetBreadcrumbs(props.match.params),
);

// --- MetricStore ---

export const metricCollectionsCatalog = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: NONE,
  },
];
export const metricCollectionDefinition = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: Page.METRIC_COLLECTIONS_CATALOG,
  },
  {
    text: id,
    href: NONE,
  },
];
export const metricCollectionWeeklyView = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: Page.METRIC_COLLECTIONS_CATALOG,
  },
  {
    text: 'Weekly view',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const metricCollectionMonthlyView = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: Page.METRIC_COLLECTIONS_CATALOG,
  },
  {
    text: 'Monthly view',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const metricCollectionQuarterlyView = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: Page.METRIC_COLLECTIONS_CATALOG,
  },
  {
    text: 'Quarterly view',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const metricCollectionYearlyView = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metric collections catalog',
    href: Page.METRIC_COLLECTIONS_CATALOG,
  },
  {
    text: 'Yearly view',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsViewMetricCollectionsCatalog = createBreadcrumbs(metricCollectionsCatalog);
export const BreadcrumbsMetricCollectionDefinition = createDynamicBreadcrumbs((props) =>
  metricCollectionDefinition(props.match.params.id),
);
export const BreadcrumbsMetricCollectionWeeklyView = createDynamicBreadcrumbs((props) =>
  metricCollectionWeeklyView(props.match.params.id),
);
export const BreadcrumbsMetricCollectionMonthlyView = createDynamicBreadcrumbs((props) =>
  metricCollectionMonthlyView(props.match.params.id),
);
export const BreadcrumbsMetricCollectionQuarterlyView = createDynamicBreadcrumbs((props) =>
  metricCollectionQuarterlyView(props.match.params.id),
);
export const BreadcrumbsMetricCollectionYearlyView = createDynamicBreadcrumbs((props) =>
  metricCollectionYearlyView(props.match.params.id),
);

export const metricsCatalog = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metrics catalog',
    href: NONE,
  },
];
export const metricsCatalogDefinition = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Metrics catalog',
    href: Page.METRICS_CATALOG,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsViewMetricsCatalog = createBreadcrumbs(metricsCatalog);
export const BreadcrumbsMetricsCatalogDefinition = createDynamicBreadcrumbs((props) =>
  metricsCatalogDefinition(props.match.params.id),
);

export const reportingTablesCatalog = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Reporting tables catalog',
    href: NONE,
  },
];
export const reportingTableDefinition = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Reporting tables catalog',
    href: Page.REPORTING_TABLE_CATALOG,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsViewReportingTablesCatalog = createBreadcrumbs(reportingTablesCatalog);
export const BreadcrumbsReportingTableDefinition = createDynamicBreadcrumbs((props) =>
  reportingTableDefinition(props.match.params.id),
);

// --- D3A Reports ---

export const listReports = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Reports',
    href: NONE,
  },
];
export const createReport = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Reports',
    href: Page.LIST_REPORTS,
  },
  {
    text: 'Create report',
    href: NONE,
  },
];
export const reportDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Reports',
    href: Page.LIST_REPORTS,
  },
  {
    text: id,
    href: NONE,
  },
];
export const requestContextDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'Request contexts',
    href: NONE,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsListReports = createBreadcrumbs(listReports);
export const BreadcrumbsCreateReport = createBreadcrumbs(createReport);
export const BreadcrumbsReportDetails = createDynamicBreadcrumbs((props) => reportDetails(props.match.params.id));
export const BreadcrumbsRequestContextDetails = createDynamicBreadcrumbs((props) =>
  requestContextDetails(props.match.params.id),
);

// --- SMUS ---

export const smusResources = [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'AWS-SMUS resources',
    href: Page.SMUS_RESOURCES,
  },
];
export const ssoGroupDetails = (id) => [
  {
    text: WEBSITE_NAME,
    href: Page.HOME,
  },
  {
    text: 'AWS-SMUS resources',
    href: Page.SMUS_RESOURCES,
  },
  {
    text: id,
    href: NONE,
  },
];
export const BreadcrumbsSmusResources = createBreadcrumbs(smusResources);
export const BreadcrumbsSsoGroupDetails = createDynamicBreadcrumbs((props) =>
  ssoGroupDetails(decodeURIComponent(props.match.params.groupMetadataId)),
);
